/** Drobná barevná matematika pro odvozování barev vzhledu (#rrggbb). */
export const HEX = /^#[0-9a-fA-F]{6}$/;

export function hexToRgb(hex: string): [number, number, number] {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
export function rgbToHex(c: [number, number, number]): string {
  return '#' + c.map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0')).join('');
}
export function mix(a: string, b: string, t: number): string {
  const x = hexToRgb(a), y = hexToRgb(b);
  return rgbToHex([x[0] + (y[0] - x[0]) * t, x[1] + (y[1] - x[1]) * t, x[2] + (y[2] - x[2]) * t]);
}
/** Přimíchá černou (0–1). */
export const shade = (hex: string, t: number): string => mix(hex, '#000000', t);
/** Přimíchá bílou (0–1). */
export const tint = (hex: string, t: number): string => mix(hex, '#ffffff', t);
/** Relativní jas 0–1. */
export function luminance(hex: string): number {
  const [r, g, b] = hexToRgb(hex).map(v => { const s = v / 255; return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4); });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
export const isDark = (hex: string): boolean => luminance(hex) < 0.35;
